module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/brag/brag-10-8b23308addba99b68dcef7615b40f47d.jpg";